// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2wOs-","col":"CardReaderDesc_col__3Bzvz","label":"CardReaderDesc_label__1A9CP"};